import React, { useState, useRef, useCallback } from 'react';
import proptypes from 'prop-types';
import { TileComponent } from './tile-component';
import { getMouseEnterHandler, getMouseLeaveHandler,
         shouldShowTooltipCondition, shouldShowUnavailableTooltipCondition } from '../../super-sku-util';

const { string, shape, bool, func } = proptypes;

export const Tile = (props) => {
  const {
    isSelected,
    isAvailable,
    isFabricType,
    value,
    onClick,
    onMouseEnter,
    onMouseLeave,
    isTooltipsEnabled,
    hoveredCombinationDetails,
    channel,
    unavailableTooltipMessage
  } = props;

  const [isHovered, setIsHovered] = useState(false);
  const anchorElRef = useRef(null);
  const isMobile = channel === 'mobile';

  const shouldShowTooltip = shouldShowTooltipCondition(isHovered, isTooltipsEnabled,
    hoveredCombinationDetails, isFabricType);

  const shouldShowUnavailableTooltip = shouldShowUnavailableTooltipCondition(unavailableTooltipMessage, isHovered,
    isAvailable, isTooltipsEnabled,
    hoveredCombinationDetails, isFabricType);

  const mouseEnter = useCallback(
    getMouseEnterHandler(isMobile, setIsHovered, onMouseEnter, anchorElRef),
    [isMobile, onMouseEnter]
  );

  const mouseLeave = useCallback(
    getMouseLeaveHandler(isMobile, setIsHovered, onMouseLeave, anchorElRef),
    [isMobile, onMouseLeave]
  );

  return (
    <TileComponent
      value={value}
      isSelected={isSelected}
      isAvailable={isAvailable}
      isFabricType={isFabricType}
      onClick={onClick}
      onTileMouseEnter={mouseEnter}
      onTileMouseLeave={mouseLeave}
      showMainTooltip={shouldShowTooltip}
      showUnavailableTooltip={shouldShowUnavailableTooltip}
      anchorRef={anchorElRef}
      hoveredCombinationDetails={hoveredCombinationDetails}
      onPopoverClose={mouseLeave}
      unavailableTooltipMessage={unavailableTooltipMessage}
    />
  );
};

Tile.displayName = 'Tile';

Tile.propTypes = {
  channel: string,
  value: string.isRequired,
  isAvailable: bool.isRequired,
  isFabricType: bool,
  isSelected: bool.isRequired,
  onClick: func.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  isTooltipsEnabled: bool,
  hoveredCombinationDetails: shape({}),
  isUnavailableTooltipsEnabled: bool,
};

Tile.defaultProps = {
  channel: 'desktop',
  hoveredCombinationDetails: {},
  isFabricType: false,
  isTooltipsEnabled: false,
  unavailableTooltipMessage: ''
};